import React from "react";
import { observable } from "mobx";
import moment from "moment";
import AgendVgmService from "../../../services/AgendVgmService";
import lscache from "lscache";
import { formatarDataCustomHTML } from "../../../utils/formatar";
import { sortCaret } from "../../comum/components/Icones";

export default class AgendVgmStore {
  @observable dados = [];
  @observable colunas = [];
  @observable defaultSorted = [];
  @observable filtros = {};
  @observable loading = false;
  @observable novaSolicitacao = {};
  @observable mensagemErro = "";
  @observable filtrado = false;
  @observable isShowingModal = false;
  service = {};

  constructor() {
    this.initializeVars();
  }

  initializeVars() {
    const isExterno = lscache.get("InternoExterno") === "E";

    this.service = new AgendVgmService();

    this.filtros = {
      container: "",
      dataInicial: '',
      dataFinal: ''
    };

    this.colunas = [
      {
        dataField: "Container",
        text: "CONTAINER",
        headerAlign: "left",
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "Cpf",
        text: "CPF",
        headerAlign: "left",
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "Nome",
        text: "NOME",
        headerAlign: "left",
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "Data",
        text: "DATA",
        headerAlign: "left",
        formatter: formatarDataCustomHTML,
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "Username",
        text: "USUÁRIO",
        headerAlign: "left",
        hidden: isExterno
      },
      {
        dataField: "Email",
        text: "E-MAIL",
        headerAlign: "left",
        hidden: isExterno
      }
    ];

    this.defaultSorted = [{ dataField: "Data", order: "desc" }];

    this.isShowingModal = false;

    this.limparNovaSolicitacao();

    // this.listar();
  }

  limparNovaSolicitacao = () => {
    this.novaSolicitacao = {
      container: "",
      cpf: "",
      nomecompleto: ""
    };
  };

  onChangeFiltro(campo, valor) {
    _.set(this.filtros, campo, valor);
  }

  preencheCampoNovaSolicitacao(campo, valor) {
    _.set(this.novaSolicitacao, campo, valor.toUpperCase());
  }

  salvarSolicitacaoVgm = async (model) => {
    try {
      const response = await this.service.adicionarSolicitacao(model);
      if (response && response.data)
          return { success: response.data.success, message: response.data.message};
    } catch (error) {
      console.log("Erro: ", error);
    }
    return { success: false, message: 'Erro ao salvar a solicitação de VGM'};
  }

  handleToggleModal = () => (this.isShowingModal = !this.isShowingModal);

  listar = async () => {
    this.loading = true;
    this.filtrado = true;
    await this.service
      .listar(
        this.filtros.container,
        this.filtros.dataInicial,
        this.filtros.dataFinal
      )
      .then(response => {
        this.dados = response.data;
      })
      .catch(erro => console.log("AgendVgmStore.listar:", erro))
      .finally(() => (this.loading = false));
  };
}



// WEBPACK FOOTER //
// ./src/modules/agend-vgm/stores/AgendVgmStore.js